import { render, staticRenderFns } from "./OwnerFormController.vue?vue&type=template&id=45b7cb5a&"
import script from "./OwnerFormController.vue?vue&type=script&lang=ts&"
export * from "./OwnerFormController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports